
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { ResendVerificationEmailActionType } from '@/types/store/actions';
import { contactUsURL, privacyPolicyURL, termsAndConditionsURL } from '@/constants/constants';

@Component({
    components: {},
})
export default class ResendVerificationEmail extends Vue {
    @Action(actions.RESEND_VERIFICATION_EMAIL)
    ResendVerificationEmail!: ResendVerificationEmailActionType;

    userEmail = '';
    contactUsURL = contactUsURL;
    privacyPolicyURL = privacyPolicyURL;
    termsAndConditionsURL = termsAndConditionsURL;

    async mounted() {
        let { email } = this.$route.params;
        this.userEmail = email ? email : '';
    }

    onSubmit(e: Event) {
        e.preventDefault();
        this.ResendVerificationEmail({ email: this.userEmail });
    }
}
